import { useEffect } from 'react';
import { HeadWrapper, Wrapper, Head, Title } from './admin-catalog-products-page.styles';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory, useParams } from 'react-router-dom';
import { ListAdminProducts } from '@widgets/list-admin-products/ui/list-admin-products';
import { DEFAULT_ADMIN_PRODUCTS_LIST_PARAMETERS } from '@entities/product/config/store-constants';
import { useAdminProductsListSharedQuery } from '@entities/product/libs/hooks/use-admin-products-list-shared-query/use-admin-products-list-shared-query';
import { FilterAdminProducts } from '@features/product/filter-admin-products/ui/filter-admin-products';
import { ProductsListDataRequest } from '@entities/product/api/product-types';
import { CreateProduct } from '@features/product/mutate-product/ui/create-product';
import { useCatalogInfoQuery } from '@entities/catalog/api/catalog-api';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const AdminCatalogProductsPage = () => {
    const history = useHistory();
    const { id: catalogId } = useParams<{ id: string }>();
    const [productsListParameters, setProductsListParameters] = useSearchParams<ProductsListDataRequest>({
        ...DEFAULT_ADMIN_PRODUCTS_LIST_PARAMETERS,
        catalogId,
    });

    const { data: catalogInfo } = useCatalogInfoQuery(Number(catalogId));
    const [getProductsList] = useAdminProductsListSharedQuery(productsListParameters);

    useEffect(() => {
        getProductsList(productsListParameters);
    }, [productsListParameters]);

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Title size='h6'>{catalogInfo?.name}</Title>
                    <FilterAdminProducts
                        productsListParameters={productsListParameters}
                        setProductsListParameters={setProductsListParameters}>
                        {catalogInfo && (
                            <CreateProduct
                                additionalProductInfo={{
                                    catalogs: [
                                        {
                                            label: catalogInfo.name,
                                            value: String(catalogInfo.id),
                                        },
                                    ],
                                }}
                            />
                        )}
                    </FilterAdminProducts>
                </Head>
            </HeadWrapper>
            <ListAdminProducts
                productsListParameters={productsListParameters}
                setProductsListParameters={setProductsListParameters}
            />
        </Wrapper>
    );
};
